export default "__VITE_ASSET__BOZghZXm__"